import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface CouponState {
  coupons: object[];
  userCoupons: object[];
}

const initialState: CouponState = {
  coupons: [],
  userCoupons: [],
};

const couponSlice = createSlice({
  name: 'coupon',
  initialState,
  reducers: {
    setCoupons: (state, action: PayloadAction<object[]>) => {
      state.coupons = action.payload;
    },
    updateCoupon: (state, action) => {
      const { id, updatedData } = action.payload;
      const existingGroup = state.coupons.find(
        (coupon) => coupon.cou_id === id
      );
      if (existingGroup) {
        Object.assign(existingGroup, updatedData);
      }
    },
    createCoupon: (state, action: PayloadAction<object>) => {
      state.coupons.push(action.payload);
    },
    deleteCoupon: (state, action: PayloadAction<number>) => {
      state.coupons = state.coupons.filter(
        (coupon) => coupon?.cou_geb_id !== action.payload
      );
    },

    setUserCoupons: (state, action: PayloadAction<object[]>) => {
      state.userCoupons = action.payload;
    },

    setUserCoupon: (state, action) => {
      const existingCoupon = state.userCoupons.find(
        (coupon) => coupon.cou_id === action.payload.cou_id
      );
      if (existingCoupon) {
        Object.assign(existingCoupon, action.payload);
      } else {
        state.userCoupons.push(action.payload);
      }
    },
  },
});

export const {
  setCoupons,
  updateCoupon,
  createCoupon,
  deleteCoupon,
  setUserCoupons,
  setUserCoupon,
} = couponSlice.actions;

export default couponSlice.reducer;
